<header [class.small]="!loggedIn" class="header">
    <app-top-navbar></app-top-navbar>
</header>
<div class="main">
    <router-outlet></router-outlet>
</div>
<footer class="footer">
    <app-footer></app-footer>
</footer>
